<template>
    <div>
        <div class="flex flex-wrap flex-lg-nowrap lg:justify-between pb-3 border-b-1">
            <div class="text-2xl text-grey-darkest mr-2 mb-2 mb-lg-0 block lg:inline w-full lg:w-auto">Manage List {{list.name}}</div>
            <button>
                <a class="hidden xl:inline border-2 border-teal bg-teal font-semibold p-2 text-white text-sm rounded-sm" @click="updateCalled()">
                    Update List
                </a>
            </button>
        </div>

        <div class="row mt-4">
            <div class="col-sm-6">
                <label class="text-grey-darkest text-sm" for="list_name"
                       :class="{'text-red': customError}">List Name <span class="text-red">*</span></label>
                <input v-model="list_name" type="text" name="list_name" id="list_name"
                       class="rounded w-full p-2 text-grey-darkest text-sm focus:outline-none border-1"
                       :class="{'border-red': customError}" @input="removeValidation()">
                <div class="text-red text-xs" v-if="customError">List name is required</div>
            </div>
        </div>

        <div class="row mt-3">
            <div class="col-sm-6">
                <label class="text-grey-darkest text-sm">Select List Type</label>
                <div class="d-flex">

                    <div class="form-check mr-4">
                        <input class="form-check-input object-radio-button" type="radio" name="object_type" id="object_type_project" value="Project" :checked="object_type === 'Project'" :disabled="object_type !== 'Project'" @change="onChange($event)">
                        <label class="form-check-label object-radio-button-label" for="object_type_project">
                            Project
                        </label>
                    </div>
                    <div class="form-check mr-4">
                        <input class="form-check-input object-radio-button" type="radio" name="object_type" id="object_type_company" value="Company" :checked="object_type === 'Company'" :disabled="object_type !== 'Company'" @change="onChange($event)">
                        <label class="form-check-label object-radio-button-label" for="object_type_company">
                            Company
                        </label>
                    </div>
                    <div class="form-check mr-4">
                        <input class="form-check-input object-radio-button" type="radio" name="object_type" id="object_type_contact" value="Contact" :checked="object_type === 'Contact'" :disabled="object_type !== 'Contact'" @change="onChange($event)">
                        <label class="form-check-label object-radio-button-label" for="object_type_contact">
                            Contact
                        </label>
                    </div>
                </div>

            </div>
        </div>

        <keep-alive>
            <component ref="activeComponent" :is="component" :masks="masks" :symbols="symbols" :user="user" :team="team" :fieldLabels="fieldLabels" :listName="list_name" :objectType="object_type" :list="list">
                <slot></slot>
            </component>
        </keep-alive>

    </div>
</template>

<script>

import Form from "../../utils/form";

import Project from './list-project';
import Contact from './list-contact';
import Company from './list-company';

export default {
    name: 'list-edit',
    props: ['masks', 'symbols', 'user', 'team', 'fieldLabels', 'list'],
    components: {Company, Contact, Project},
    data() {
        return {
            component:this.capitalize(this.list.object_type),
            list_name : this.list.name ?? null,
            object_type: this.capitalize(this.list.object_type),
            customError: false
        }
    },
    methods: {
        capitalize(s){
            return s[0].toUpperCase() + s.slice(1);
        },
        onChange(event) {
            this.component = event.target.value
            this.object_type = event.target.value
        },
        updateCalled() {
            if(!this.list_name) {
                this.customError = true;
            }else{
                this.customError = false;
                this.$refs.activeComponent.update();
            }
        },
        removeValidation() {
            this.customError = !this.list_name;
        }
    }
}
</script>
<style scoped>
.object-radio-button{
    transform: scale(1.5);
}
.object-radio-button:checked~.object-radio-button-label::before {
    color: #fff;
    border-color: #7B1FA2;
}

.object-radio-button:checked~.object-radio-button-label::before {
    background-color: green;
}
</style>
